"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddMeterPhoto = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var components_1 = require("../../../../shared/core/components");
var analytics_subjects_1 = require("../../../kapi-meter-reads/analytics-subjects");
var analytics_subjects_2 = require("../../analytics-subjects");
var copy_1 = require("../../copy");
var AddMeterPhoto_styled_1 = require("./AddMeterPhoto.styled");
var CameraIcon_1 = require("./CameraIcon");
var utils_1 = require("./utils");
var AddMeterPhoto = function (_a) {
    var _b;
    var onImageChange = _a.onImageChange;
    var dispatch = (0, ui_tools_1.useAnalytics)().dispatch;
    var _c = (0, core_1.useComponents)(), Heading4 = _c.Heading4, SecondaryCTAButton = _c.SecondaryCTAButton, ErrorNotification = _c.ErrorNotification;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var _d = __read((0, react_1.useState)(null), 2), error = _d[0], setError = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), isProcessing = _e[0], setIsProcessing = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), hasImg = _f[0], setHasImg = _f[1];
    var inputRef = (0, react_1.useRef)(null);
    var previewRef = (0, react_1.useRef)(null);
    var handlePhotoUpload = function (e) {
        e.preventDefault();
        if (inputRef.current) {
            inputRef.current.click();
        }
    };
    var handleImgChange = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, file, isValidType, resized, isValidSize, preview, err_1;
        var _b, _c, _d, _e, _f;
        var _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    setIsProcessing(true);
                    if (!inputRef.current) return [3 /*break*/, 4];
                    _a = __read((_g = inputRef.current.files) !== null && _g !== void 0 ? _g : [], 1), file = _a[0];
                    if (!(file && previewRef.current)) return [3 /*break*/, 4];
                    setError(null);
                    isValidType = (0, utils_1.validateImageType)(file);
                    if (!isValidType) {
                        setError('type');
                        setIsProcessing(false);
                        setHasImg(false);
                        previewRef.current.src = '';
                        dispatch({
                            name: analytics_subjects_2.METER_PHOTO_VALIDATION_ERROR,
                            type: 'render',
                            properties: (_b = {
                                    error: 'type'
                                },
                                _b[core_1.INTERNAL_EVENT_FLAG] = true,
                                _b),
                        });
                        return [2 /*return*/];
                    }
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, utils_1.resizeImage)(file)];
                case 2:
                    resized = _h.sent();
                    isValidSize = (0, utils_1.validateImageSize)(resized);
                    if (!isValidSize) {
                        setError('size');
                        setIsProcessing(false);
                        setHasImg(false);
                        previewRef.current.src = '';
                        dispatch({
                            name: analytics_subjects_2.METER_PHOTO_VALIDATION_ERROR,
                            type: 'render',
                            properties: (_c = {
                                    error: 'size'
                                },
                                _c[core_1.INTERNAL_EVENT_FLAG] = true,
                                _c),
                        });
                        return [2 /*return*/];
                    }
                    preview = URL.createObjectURL(resized);
                    previewRef.current.src = preview;
                    setIsProcessing(false);
                    onImageChange(resized);
                    setHasImg(true);
                    dispatch({
                        name: analytics_subjects_2.METER_PHOTO_SELECT_SUCCESS,
                        type: 'render',
                        properties: (_d = {
                                fileSize: resized.size
                            },
                            _d[core_1.INTERNAL_EVENT_FLAG] = true,
                            _d),
                    });
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _h.sent();
                    // resizing failed
                    console.error(err_1);
                    setHasImg(false);
                    dispatch({
                        name: analytics_subjects_2.METER_PHOTO_RESIZE_ERROR,
                        type: 'render',
                        properties: (_e = {
                                error: err_1
                            },
                            _e[core_1.INTERNAL_EVENT_FLAG] = true,
                            _e),
                    });
                    return [3 /*break*/, 4];
                case 4:
                    // on cancel
                    dispatch({
                        name: analytics_subjects_2.METER_PHOTO_CANCELLED,
                        type: 'render',
                        properties: (_f = {},
                            _f[core_1.INTERNAL_EVENT_FLAG] = true,
                            _f),
                    });
                    setIsProcessing(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(AddMeterPhoto_styled_1.StyledUpload, null,
        react_1.default.createElement(Heading4, null,
            react_1.default.createElement(Copy, { copyKey: "addPhotoTitle" }),
            ' '),
        error && (react_1.default.createElement(ErrorNotification, { id: "add-photo-error" },
            react_1.default.createElement(Copy, { copyKey: error === 'size'
                    ? 'addPhotoValidationSize'
                    : 'addPhotoValidationType' }))),
        react_1.default.createElement(components_1.LoadingContent, { loading: isProcessing },
            react_1.default.createElement(Copy, { copyKey: "addPhotoCopy" }),
            react_1.default.createElement(AddMeterPhoto_styled_1.StyledPreview, { ref: previewRef }),
            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_2.METER_PHOTO_SELECT, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b[analytics_subjects_1.KAPI_ONLY] = true, _b) },
                react_1.default.createElement(SecondaryCTAButton, { onClick: handlePhotoUpload },
                    react_1.default.createElement(AddMeterPhoto_styled_1.StyledButton, null,
                        react_1.default.createElement(CameraIcon_1.CameraIcon, null),
                        react_1.default.createElement(Copy, { copyKey: hasImg ? 'changePhotoCTA' : 'addPhotoCTA' }))))),
        react_1.default.createElement(AddMeterPhoto_styled_1.StyledInput, { "aria-hidden": "true", type: "file", name: "meterPhoto", ref: inputRef, onChange: handleImgChange, 
            // use image/* so that phones will still open camera
            accept: "image/*" })));
};
exports.AddMeterPhoto = AddMeterPhoto;
